import api from '@core/services/api/_api';
import Application from '@core/classes/Applications/Application';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useCustomerApplicationStore = defineStore('customerApplication', () => {
	const customerApplication = ref<Application | null>(null);

	const getCustomerApplication = async (customerId: string) => {
		try {
			const customerAppData = await api.applications.getByCustomer(customerId);
			if (customerAppData?.status == 200 && customerAppData.data) {
				customerApplication.value = new Application(customerAppData.data);
			}
		} catch (error) {
			console.error('error', error);
		}
	};
	const clearCustomerApplication = () => {
		customerApplication.value = new Application();
	};
	const setCustomerApplication = (newCustomerApplication: any) => {
		customerApplication.value = new Application(newCustomerApplication);
	};

	return {
		customerApplication,
		getCustomerApplication,
		clearCustomerApplication,
		setCustomerApplication,
	};
});
